// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { currencyConfig } from '../../../config/currency.config';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';

export default class GatewayTemplatesPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'publicGatewayTemplates';
        this.Server = this.props.context.getState().server.publicGatewayTemplates;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['templateName', 'currency'];
        this.showDatePicker = false;

        const defaultHead = [
            {
                id: 'templateName',
                label: 'templateName',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'gatewayId',
                label: 'gateway',
                alignRight: false,
                cell: 'Select',
                show: 'name',
                from: 'publicGateways',
                object: 'gateway',
                displayGrid: true
            },
            {
                id: 'gatewayAccountId',
                label: 'gatewayAccount',
                alignRight: false,
                cell: 'Select',
                show: 'name',
                from: 'accountingGatewayAccounts',
                object: 'gatewayAccount',
                displayGrid: true
            },
            {
                id: 'gatewaySettingId',
                label: 'gatewaySettings',
                alignRight: false,
                cell: 'Select',
                show: 'templateName',
                from: 'publicGatewaySettings',
                object: 'gatewaySetting',
                displayGrid: true
            },
            {
                id: 'currency',
                label: 'currency',
                alignRight: false,
                cell: 'Items',
                type: 'currency',
                noTranslate: true,
                items: Object.keys(currencyConfig),
                displayGrid: true
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);
        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
